export const REQUEST = "containers/CitySearchInput/REQUEST"
export const RECEIVE = "containers/CitySearchInput/RECEIVE"
